import useGetUserToken from "../utils/getUserToken";
import { fetchData, postData, putData } from "../utils/apiUtils";
export const employeeDashboardData= async () => {
  const responseData = await fetchData("employee/dashboard");
  return responseData;
};
export const branchAttendance= async (date) => {
  const responseData = await fetchData(`employee/dashboard/attendance?date=${encodeURIComponent(date)}`);
  return responseData;
};